export default {"src":"/_next/static/media/Frame_14415.e3ca2bda.svg","height":160,"width":161,"blurWidth":0,"blurHeight":0};